import type { NotificationDto } from '@/core/data/notification/notification.interface';
import type { NotificationRepository } from '@/core/data/notification/notification.repository';
import type { NotificationApiOptions } from '@/core/network/api/notification/notification.api';
import type { ApiError, Result } from '@/core/network/http/httpClient.interface';
import { generalError } from '@/core/network/http/httpError';

export class NotificationService {
  private readonly repository: NotificationRepository;

  constructor(repository: NotificationRepository) {
    this.repository = repository;
  }

  async getNotifications(options?: NotificationApiOptions): Promise<Result<NotificationDto[]>> {
    try {
      const response = await this.repository.getNotifications(options);
      return response?.data
        ? // @ts-ignore
          { data: response.data, cursor: response.cursor, unreadCount: response.unreadCount }
        : { error: generalError() };
    } catch (error) {
      return {
        error: error as ApiError,
      };
    }
  }

  async markAsRead(id: string): Promise<Result<{ unreadCount: number }>> {
    try {
      const response = await this.repository.markAsRead(id);
      return response?.data ? { data: response.data, cursor: response.cursor } : { error: generalError() };
    } catch (error) {
      return {
        error: error as ApiError,
      };
    }
  }

  async markAllAsRead(): Promise<Result<{ unreadCount: number }>> {
    try {
      const response = await this.repository.markAllAsRead();
      return response?.data ? { data: response.data, cursor: response.cursor } : { error: generalError() };
    } catch (error) {
      return {
        error: error as ApiError,
      };
    }
  }

  async deleteAll(): Promise<Result<{ deletedCount: number }>> {
    try {
      const response = await this.repository.deleteAll();
      return response?.data ? { data: response.data } : { error: generalError() };
    } catch (error) {
      return {
        error: error as ApiError,
      };
    }
  }
}
